.skeleton {
	display: block;
	background-color: color-mix(in srgb, var(--colour-text-secondary) 18%, transparent);
	animation: pulse 1.4s ease-in-out infinite;

	&[data-variant='text'] {
		block-size: 0.75em;
		margin-block: 0.2em;
		border-radius: var(--radius-sm);
	}

	&[data-variant='block'] {
		block-size: 6rem;
		border-radius: var(--radius-md);
	}

	&[data-variant='circle'] {
		inline-size: 2.5rem;
		block-size: 2.5rem;
		border-radius: var(--radius-full);
	}
}

@keyframes pulse {
	50% {
		opacity: 0.45;
	}
}

@media (prefers-reduced-motion: reduce) {
	.skeleton {
		opacity: 0.7;
		animation: none;
	}
}
